module.exports = __webpack_public_path__ + "img/povecalo.477893ee.svg";